module.exports = __webpack_public_path__ + "static/img/h1.5ce9b70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour3/h1.jpg
// module id = PnOE
// module chunks = 0